/**
 * 章节API服务
 */
import axios from 'axios';
import { getApiUrl } from './config';

/**
 * 获取章节详情
 * @param {Number} id - 章节ID
 * @returns {Promise} - 返回章节详情数据
 */
export const getChapterDetail = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(getApiUrl('/api/chapter/detail'), { 
      params: { 
        id,
        token
      } 
    });
    return response.data;
  } catch (error) {
    console.error('获取章节详情失败:', error);
    throw error;
  }
};

/**
 * 获取章节列表
 * @param {Number} comicId - 漫画ID
 * @param {Object} params - 查询参数 {page, limit}
 * @returns {Promise} - 返回章节列表数据
 */
export const getChapterList = async (comicId, params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(getApiUrl('/api/chapter/list'), { 
      params: { 
        comic_id: comicId,
        token,
        ...params
      } 
    });
    return response.data;
  } catch (error) {
    console.error('获取章节列表失败:', error);
    throw error;
  }
};

/**
 * 购买章节
 * @param {Number} chapterId - 章节ID
 * @returns {Promise} - 返回购买结果
 */
export const buyChapter = async (chapterId) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('请先登录');
    }
    
    console.log('购买章节请求参数:', { chapter_id: chapterId, token });
    
    const response = await axios.post(
      `${getApiUrl('/api/chapter/buy')}?token=${token}`, 
      { 
        chapter_id: chapterId
      },
      { 
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    
    console.log('购买章节API响应:', response.data);
    return response.data;
  } catch (error) {
    console.error('购买章节失败:', error);
    throw error;
  }
}; 